import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state/app_state';
import { getTermValue } from '../../../../../../../json_query/reducers/helpers';
import { changeIsDemolishedInMoscowProgramm } from '../../../../../../state/advanced/demolished_in_moscow_programm';

import { DemolishedInMoscowProgramm as DemolishedInMoscowProgrammComponent } from './demolishedInMoscowProgramm';

export const DemolishedInMoscowProgramm = connect(
  (state: IAppState) => ({
    value: getTermValue('demolished_in_moscow_programm')(state.filters.jsonQuery),
  }),
  (dispatch: Dispatch) => ({
    onChange: (value: boolean | undefined) => dispatch(changeIsDemolishedInMoscowProgramm(value)),
  }),
)(DemolishedInMoscowProgrammComponent);
